import { render, staticRenderFns } from "./TabletAppSettingsTab.vue?vue&type=template&id=24ff3cf1&scoped=true"
import script from "./TabletAppSettingsTab.vue?vue&type=script&lang=js"
export * from "./TabletAppSettingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ff3cf1",
  null
  
)

export default component.exports